module.exports = __webpack_public_path__ + "img/add-to-portfolio-light.c65c7e6.svg";